module.exports = __webpack_public_path__ + "img/lyg.73ba1e7f.png";